import { render, staticRenderFns } from "./ResubmitRemittanceSummary.vue?vue&type=template&id=51c7bcd8&scoped=true"
import script from "./ResubmitRemittanceSummary.vue?vue&type=script&lang=js"
export * from "./ResubmitRemittanceSummary.vue?vue&type=script&lang=js"
import style0 from "./ResubmitRemittanceSummary.vue?vue&type=style&index=0&id=51c7bcd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c7bcd8",
  null
  
)

export default component.exports